module.exports = __webpack_public_path__ + "static/media/resource2.5118c380.svg";